import { render, staticRenderFns } from "./Rules.vue?vue&type=template&id=2ed83d5d&scoped=true&"
import script from "./Rules.vue?vue&type=script&lang=js&"
export * from "./Rules.vue?vue&type=script&lang=js&"
import style0 from "./Rules.vue?vue&type=style&index=0&id=2ed83d5d&prod&scoped=true&lang=css&"
import style1 from "./Rules.vue?vue&type=style&index=1&id=2ed83d5d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed83d5d",
  null
  
)

export default component.exports